export const PRIVACY_POLICY_URL = 'https://goodstack.org/legal/privacy-policy';
